module.exports = __webpack_public_path__ + "assets/img/b4-5.c22ff1f8.png";